import { render } from "./HighLevelReport.vue?vue&type=template&id=a8b468d4&scoped=true"
import script from "./HighLevelReport.vue?vue&type=script&lang=js"
export * from "./HighLevelReport.vue?vue&type=script&lang=js"

import "./HighLevelReport.vue?vue&type=style&index=0&id=a8b468d4&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shuha\\Documents\\Wisdom guide front\\wg-frontend-v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8b468d4"]])

export default __exports__